// extracted by mini-css-extract-plugin
export var a = "KrnAccordion-module--a--K9fIP";
export var accordion = "KrnAccordion-module--accordion--Y2GWX";
export var accordion__button = "KrnAccordion-module--accordion__button--l56c8";
export var accordion__item = "KrnAccordion-module--accordion__item--hVoRz";
export var accordion__layout = "KrnAccordion-module--accordion__layout--VTXug";
export var accordion__panel = "KrnAccordion-module--accordion__panel--lGsde";
export var fadein = "KrnAccordion-module--fadein--NG5Yr";
export var q = "KrnAccordion-module--q--u-H-g";